import apiClient from '@/services/axios'

export async function getFreeUserPointsConfiguration() {
    const response = await apiClient.get('/TierLevels/free-user-points-configuration')
    if (response) {
        return response.data
    }
    throw new Error('Unable to fetch free user points configuration.')
}

export async function updateFreeUserPointsEnabled(enabled) {
    const response = await apiClient.put('/TierLevels/free-user-points-enabled', { enabled })
    if (response) {
        return response.data
    }
    throw new Error('Unable to update free user points enabled setting.')
}

export async function updateFreeUserPointsPerksConfigurations(configurations) {
    const response = await apiClient.put('/TierLevels/free-user-points-perks-configurations', {
        perksConfigurations: configurations
    })
    if (response) {
        return response.data
    }
    throw new Error('Unable to update free user points perks configurations.')
}
